// extracted by mini-css-extract-plugin
module.exports = {"narrow":"container_narrow__1uAIV","fade-in":"container_fade-in__3q1ow"};